import { useLocation } from "react-router-dom";
import { menuConfig } from "../menuConfig";

export const DASHBOARD_ROUTE = "/app/dashboard";

const ALL_ROUTES = [DASHBOARD_ROUTE, ...menuConfig.flatMap((group) => group.items.map((item) => item.route))];

/**
 * The menu route the current page belongs to: the longest menu route that is the page itself or a
 * parent of it. "/app/students/guardians" -> "/app/students/guardians" (not "/app/students"), while
 * "/app/students/new" or "/app/students/123" -> "/app/students". Null when no menu item matches.
 */
export const activeMenuRoute = (pathname: string): string | null =>
  ALL_ROUTES.filter((route) => pathname === route || pathname.startsWith(route + "/")).sort((a, b) => b.length - a.length)[0] ?? null;

/** activeMenuRoute for the current location. Compare menu routes against it with ===. */
export const useActiveMenuRoute = (): string | null => activeMenuRoute(useLocation().pathname);
